var exports = {
  "Sc": "UserArea.module__userAreaInnerWrapper___eFphRG",
  "cU": "UserArea.module__userAreaContainer___eFphRG",
  "jC": "UserArea.module__popoutContainer___eFphRG",
  "oT": "UserArea.module__voiceConnectionWrapper___eFphRG",
  "eF": "UserArea.module__userInfo___eFphRG",
  "vu": "UserArea.module__active___eFphRG",
  "N6": "UserArea.module__userInfoText___eFphRG",
  "nT": "UserArea.module__userName___eFphRG",
  "ag": "UserArea.module__userStatus___eFphRG",
  "uh": "UserArea.module__userStatusLabel___eFphRG" + " " + "UserArea.module__userStatus___eFphRG",
  "XW": "UserArea.module__userCustomStatus___eFphRG" + " " + "UserArea.module__userStatus___eFphRG",
  "oM": "UserArea.module__hoverRoll___eFphRG",
  "n6": "UserArea.module__defaultState___eFphRG",
  "yo": "UserArea.module__hovered___eFphRG",
  "EE": "UserArea.module__forceHover___eFphRG",
  "gO": "UserArea.module__controlsContainer___eFphRG",
  "uH": "UserArea.module__controlButton___eFphRG",
  "DY": "UserArea.module__contextMenuHover___eFphRG",
  "r9": "UserArea.module__disabled___eFphRG",
  "pd": "UserArea.module__controlIcon___eFphRG",
  "se": "UserArea.module__controlIconWithDot___eFphRG",
  "PP": "UserArea.module__controlDot___eFphRG",
  "ZF": "UserArea.module__companionActive___eFphRG",
  "OR": "UserArea.module__companionIndicator___eFphRG",
};

module.exports = exports;
